export const darkTheme = {
  bg: '#0D120E',
  card: '#1A1F1B',
  text: '#ffffff',
  subtext: '#A1ACAB',
  accent: '#DFFF00', // Eco-Highlight
  sidebarAccent: '#6E7F6B', // Forest Green
  surfaceMuted: '#222924',
  success: '#7AD69A',
  danger: '#FF8A8A'
}

export const lightTheme = {
  bg: '#F0F0EC',
  card: '#FFFFFF',
  text: '#000000',
  subtext: '#636E72',
  accent: '#DFFF00', // Eco-Highlight
  sidebarAccent: '#6E7F6B', // Forest Green
  surfaceMuted: '#F3F6F4',
  success: '#2E7D32',
  danger: '#C62828'
}
